import React from 'react';
import '../styles/Legal.css';

const Privacy = () => (
  <div className="legal-page">
    <h1>Politique de confidentialité</h1>
    <p>
      Nous respectons votre vie privée et nous engageons à protéger vos informations personnelles.
    </p>
    <h2>1. Collecte des informations</h2>
    <p>
      Nous collectons uniquement les informations nécessaires à la fourniture du service.
    </p>
    <h2>2. Utilisation des informations</h2>
    <p>
      Vos informations ne seront jamais vendues ou partagées sans votre consentement, sauf obligation légale.
    </p>
    <h2>3. Sécurité</h2>
    <p>
      Nous mettons en œuvre des mesures de sécurité pour protéger vos données.
    </p>
    <h2>4. Droits des utilisateurs</h2>
    <p>
      Vous pouvez demander la modification ou la suppression de vos données personnelles à tout moment.
    </p>
    <h2>5. Contact</h2>
    <p>
      Pour toute question concernant la confidentialité, veuillez nous contacter.
    </p>
  </div>
);

export default Privacy;
